export default __webpack_public_path__ + "static/media/visa.555bf4b8.svg";